import { render, staticRenderFns } from "./EmployeeBankAccountNomineeDetailsReport.vue?vue&type=template&id=bd3a6134"
import script from "./EmployeeBankAccountNomineeDetailsReport.vue?vue&type=script&lang=js"
export * from "./EmployeeBankAccountNomineeDetailsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports